angular.module("avant.customer_applications.controllers").controller "CustomerApplicationsAdditionalInformationCtrl", [
  "$scope", "$parse", "$stateParams", "$location", "$timeout", "$modal", "$controller", "$cookies", "CustomerApplicationService", "ApplicationService", "ContractService", "ConfigService", "$filter", "SmartyStreetsService", "$window",
  ($scope, $parse, $stateParams, $location, $timeout, $modal, $controller, $cookies, CustomerApplicationService, ApplicationService, ContractService, ConfigService, $filter, SmartyStreetsService, $window) ->

    $scope.page = "additional_information"

    $scope.$emit('customer_application:data', ApplicationService.data)
    angular.extend($scope, $controller('CustomerApplicationsMixinCtrl', {$scope: $scope, CustomerApplicationService: CustomerApplicationService, ApplicationService: ApplicationService}))

    # Register Page View
    $scope.trackVisit()

    $scope.$on "$viewContentLoaded", ->
      $scope.tealiumView("#{$scope.page}_view", { application_page: $scope.page })

    $scope.$watch 'mailing_address.is_military_address', (newValue, oldValue) ->
      if newValue
        $scope.mailing_address.is_po_box = false
        $scope.update("mailing_address.is_po_box")

    $scope.$watch 'mailing_address.is_po_box', (newValue, oldValue) ->
      if newValue
        $scope.mailing_address.is_military_address = false
        $scope.update("mailing_address.is_military_address")

    $scope.$watch 'mailing_address.country', (newValue, oldValue) ->
      if newValue && newValue != 'US'
        $scope.mailing_address.is_po_box = false
        $scope.mailing_address.is_military_address = false
        $scope.update(["mailing_address.is_po_box", "mailing_address.is_military_address"])

    $scope.getAddresses = (prefix) ->
      SmartyStreetsService.suggest(prefix)

    $scope.setAddress = (item) ->
      $scope.employer_address.address_1 = item.street_line
      $scope.employer_address.city = item.city
      $scope.employer_address.state = item.state
      $scope.update("employer_address.city")
      $scope.update("employer_address.state")

    $scope.submit = ->
      noServerSideErrors = (resp) ->
        _.isEmpty resp.server_side_errors
      notOnDeclinePage = (resp) ->
        resp.page != 'declined'
      showContractAtEnd = (resp) ->
        resp.data.config.show_contract_at_end?

      $scope.$emit 'conversion:action', 'submit', 'additional_information'
      $scope.submitWrapper (response_data) ->
        if noServerSideErrors(response_data) && showContractAtEnd(response_data) && notOnDeclinePage(response_data)
          ContractService.readyToViewContract(response_data.data.customer_application.id).then (response) ->
            if response.data.can_view_contract
              redirectWrapper(response_data)
            else
              $scope.tealiumEvent("#{$scope.page}_submit", { application_page: $scope.page })
              queryParams = "?customer_application_id=#{response_data.data.customer_application.id}&reason=contract"
              $window.location.replace("#{ConfigService.completePrefix}#{queryParams}")
        else
          redirectWrapper(response_data)

    $scope.conditionalOccupationValues = ->
      $scope.page_requirements[0].fields.customer_application_metadata?.occupation?.conditional_values || {}

    $scope.setOccupationOptions = (newValue) ->
      values = $scope.conditionalOccupationValues()
      $scope.occupation_options = if values[newValue]
                                    values[newValue]
                                  else
                                    $scope.customer_application_metadata.occupation = " "
                                    {}

    if $scope.customer_application_metadata?.industry
      $scope.setOccupationOptions($scope.customer_application_metadata.industry)

    $scope.occupationOptionsEmpty = ->
      angular.equals({}, $scope.occupation_options)

    $scope.conditionalIndustryValues = ->
      $scope.page_requirements[0].fields.employment?.industry?.conditional_values || {}

    $scope.setConditionalIndustryOptions = (industry_category) ->
      values = $scope.conditionalIndustryValues()
      $scope.conditional_industry_options = values[industry_category] || {}

    $scope.atAddressLessThanOneYear = (address) ->
      dayInMilliseconds = 1000 * 60 * 60 * 24
      startDate = address.address_start_date
      return false unless startDate
      today = new Date()
      date = new Date(startDate)
      today.setHours(0,0,0,0)
      diffTime = Math.abs(today.getTime() - date.getTime())
      diffDays = Math.ceil(diffTime / dayInMilliseconds)
      diffDays < 365 && date <= today

    redirectWrapper = (response_data) ->
      $scope.redirectIfDifferentPage response_data, ->
        # some error occurred as page didn't change
        $scope.closeAllLoadingModals()
        $scope.showServerSideErrors(response_data.server_side_errors)
]
